<template>
    <div class="p-3" v-if="data">
        <div class="row">
            <div class="col-lg-12">
                <router-link to="/perfil/mensajes" class="btn b-transparent my-2 float-right">
                    <i class="fas fa-long-arrow-alt-left"></i>
                    Volver a mensajes
                </router-link>
            </div>
        </div>
        <div class="confirmed" v-if="data.confirm">
            <div class="row">
                <div class="col-lg-12">
                    <WriteMessage :data="data" />
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-lg-12">
                    <label for=""><i class="fas fa-stream"></i> Mensajes</label>
                    <transition-group name="fade">
                        <MessageItem v-for="message in sortedArray" :key="message.id" :data="message"/>
                    </transition-group>
                </div>
            </div>
        </div>
        <div v-if="!data.confirm">
            <div class="row">
                <div class="col-lg-12">
                    <ConfirmMessage :job="data.job" :user="data.from" :data="data"/>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
<script>
import WriteMessage from './components/WriteMessage'
import MessageItem from './components/MessageItem'
import ConfirmMessage from './components/ConfirmMessage'
export default {
    components:{
        'WriteMessage': WriteMessage,
        'MessageItem': MessageItem,
        'ConfirmMessage': ConfirmMessage
    },
    data() {
        return {
            data: {},
        }
    },
    computed:{
        sortedArray: function() {
            function compare(a, b) {
                if (a.id > b.id)
                return -1;
                if (a.id < b.id)
                return 1;
                return 0;
            }  return this.data.messages.sort(compare);
        }
    },
    methods:{
        loadMessages(id){
            this.api.get("conversation/read?conversation_url=" + id).then(({data}) => {
                this.data = data
                // this.$bus.$emit("message")
            })
        },

    },
    created(){
        let id = this.$route.params.id
        if(id == undefined){
            this.$router.push('/perfil/mensajes')
        } else {
            this.loadMessages(id)
        }

        this.bus.$on('confirm', data => {
            this.data = data
            location.reload()
        })

        this.bus.$on('message', data => {
            this.data.messages.push(data)
        })

        this.$bus.$emit("message")
    }
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/messages/ConversationRead.vue